import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconPhotoAlbum = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "440 2803 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "silver",
		d: "M446.308 2824.5C445.803 2824.5 445.375 2824.32 445.025 2823.97C444.675 2823.62 444.5 2823.2 444.5 2822.69V2807.31C444.5 2806.8 444.675 2806.37 445.025 2806.02C445.375 2805.67 445.803 2805.5 446.308 2805.5H457.692C458.197 2805.5 458.625 2805.67 458.975 2806.02C459.325 2806.37 459.5 2806.8 459.5 2807.31V2822.69C459.5 2823.2 459.325 2823.62 458.975 2823.97C458.625 2824.32 458.197 2824.5 457.692 2824.5H446.308ZM446.308 2823H457.692C457.769 2823 457.84 2822.97 457.904 2822.9C457.968 2822.84 458 2822.77 458 2822.69V2807.31C458 2807.23 457.968 2807.16 457.904 2807.09C457.84 2807.03 457.769 2807 457.692 2807H456V2813.56L453.75 2812.21L451.5 2813.56V2807H446.308C446.231 2807 446.16 2807.03 446.096 2807.09C446.032 2807.16 446 2807.23 446 2807.31V2822.69C446 2822.77 446.032 2822.84 446.096 2822.9C446.16 2822.97 446.231 2823 446.308 2823ZM447.365 2820.75H456.712L453.654 2816.67L451.077 2820.02L449.461 2817.97L447.365 2820.75Z"
	})
});
export default SvgIconPhotoAlbum;
